import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslations } from 'next-intl';
import {
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Box,
  Typography,
  Grid2,
} from '@mui/material';
import { NAV_CATEGORY } from 'layouts/Main/constants';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SolutionNav from '../NavContainer/SolutionNav';
import ResourceNav from '../NavContainer/ResourceNav';
import AboutNav from '../NavContainer/AboutNav';
import ProductionNav from '../NavContainer/ProductionNav';
import isEmpty from 'lodash/isEmpty';

interface Props {
  title: string;
  items: Array<PageItem>;
  showPanel?: boolean;
  type?: number;
}

const NavItem = ({ title, items, showPanel, type }: Props): JSX.Element => {
  const t = useTranslations('Home.nextNav');
  const theme = useTheme();
  const [activeLink, setActiveLink] = useState('');
  useEffect(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);

  const hasActiveLink = () =>
    items.find((i) => activeLink && activeLink.includes(i.href));

  return (
    <Box>
      {showPanel === false ? (
        <Box
          my={1}
          onClick={(e) => {
            if (!isEmpty(items)) {
              window.location.href = items[0].href;
            }
          }}
          sx={{
            cursor: 'pointer',
          }}
        >
          <Typography
            fontWeight={hasActiveLink() ? 600 : 400}
            color={hasActiveLink() ? 'primary' : 'text.primary'}
          >
            {title}
          </Typography>
        </Box>
      ) : (
        <Accordion
          disableGutters
          elevation={0}
          sx={{ backgroundColor: 'transparent' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ padding: 0 }}
          >
            <Typography
              fontWeight={hasActiveLink() ? 600 : 400}
              color={hasActiveLink() ? 'primary' : 'text.primary'}
            >
              {title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: 0 }}>
            <Grid2 container spacing={1} size={12}>
              {type === NAV_CATEGORY.Production.value && (
                <ProductionNav activeLink={activeLink} />
              )}
              {type === NAV_CATEGORY.Solution.value && (
                <SolutionNav activeLink={activeLink} />
              )}
              {type === NAV_CATEGORY.Resource.value && (
                <ResourceNav activeLink={activeLink} />
              )}
              {type === NAV_CATEGORY.About.value && (
                <AboutNav activeLink={activeLink} />
              )}
            </Grid2>
          </AccordionDetails>
        </Accordion>
      )}
    </Box>
  );
};

export default NavItem;
